import {API} from "../../Services";
import {AxiosCache} from "../../Services/AxiosCache/AxiosCache";

async function StoreOnlineAddress() {
    let token = localStorage.getItem('token');
    return API.get(`/users/address/`, {headers: {'Authorization': `Bearer ${token}`}});
}

async function DeleteOnlineAddress(id) {
    let token = localStorage.getItem('token');
    return API.delete(`/users/address/${id}`, {headers: {'Authorization': `Bearer ${token}`}});
}

async function ChangeDefaultAddress(addressId, muid) {
    let token = localStorage.getItem('token');
    return API.put(`/shop/cart/`, {
        address: addressId,
        merchant_uid: muid

    }, {
        params:{
          merchant:  muid
        },
        headers: {'Authorization': `Bearer ${token}`}});
}

async function GetGuestBasket() {
    return new Promise((resolve, reject) => {
        let guestBasketLocal = localStorage.getItem("basket");
        console.log("ssssssss", guestBasketLocal)
        if (guestBasketLocal) {
            let parsed = JSON.parse(guestBasketLocal);
            let sim = parsed.map(g => {
                return {product:g.product, quantity: g.count}
            })

            console.log("xxxsss", sim)

            resolve({data: {items: sim}})
        } else {
            console.log("vvvv")
            resolve({data: {items: []}})
        }

    })
}


async function getCatsTreeApi_v2(mId) {
    if(mId){

        let url =`/shop/${mId}/nested-categories/`
        let config = {}
        return  await AxiosCache({url,config,time: 4*60*1000})
        // const resp = await API.get(`/shop/${mId}/nested-categories/`);
    }
}

async function getCatsTreeApi(mId) {
    if(mId){
        return API.get(`/shop/${mId}/nested-categories/`);
    }


}




async function GetBasket(merchantId=null) {
    let token = localStorage.getItem('token');

    if (!token)
        return GetGuestBasket()

    return API.get(`/shop/cart/`, {
        params:{
            merchant:merchantId
        },
        headers: {
        'Authorization': `Bearer ${token}`
    }});
}


async function AddToGuestBasket(merchantId, productId, product) {

    return new Promise((resolve, reject) => {
        let obj = {
            merchant_uid: merchantId,
            product_id: productId,
            product: product
        }
        let guestBasketLocal = localStorage.getItem("guestBasket");
        if (guestBasketLocal) {
            let guestData = JSON.parse(guestBasketLocal);
            guestData.push(obj)
            localStorage.setItem("guestBasket", JSON.stringify(guestData))
        } else {
            let guestData = [];
            guestData.push(obj)
            localStorage.setItem("guestBasket", JSON.stringify(guestData))
        }

        resolve(true)
    })

}

async function AddBasket(merchantId, productId, product) {
    let token = localStorage.getItem('token');

    if (!token)
        return true

    return API.post(`/shop/cart/`, {
        merchant_uid: merchantId,
        product_id: productId
    }, {headers: {'Authorization': `Bearer ${token}`}});
}


async function RemoveFromGuestBasket(merchantId, productId) {

    return new Promise((resolve, reject) => {

        let guestBasketLocal = localStorage.getItem("guestBasket");
        if (guestBasketLocal) {
            let guestData = JSON.parse(guestBasketLocal);
            let removeIndex = guestData.map(item => item.productId).indexOf(productId);
            let removed = ~removeIndex && guestData.splice(removeIndex, 1);
            localStorage.setItem("guestBasket", JSON.stringify(guestData))
        }

        resolve(true)
    })

}

async function RemoveBasket(merchantId, productId) {
    let token = localStorage.getItem('token');

    if (!token)
        return true

    return API.post(`/shop/cart/items/decrease/`, {
        merchant_uid: merchantId,
        product_id: productId
    }, {
        params:{merchant:merchantId},
        headers: {'Authorization': `Bearer ${token}`}});
}



async function getCouriers_api(merchantId,cUid) {
    console.log("444444444444444 444",merchantId,cUid)
    let token = localStorage.getItem('token');
    return API.get(`/users/${merchantId}/merchant_couriers/address/${cUid}`, {
        headers: {
            'Authorization': `Bearer ${token}`
        }});
}

async function getIntervalForCourier_api(merchantId,cId) {
    let token = localStorage.getItem('token');
    return API.get(`/users/${merchantId}/merchant_couriers/${cId}`, {
        headers: {
            'Authorization': `Bearer ${token}`
        }});
}


export {
    getIntervalForCourier_api,
    getCouriers_api,
    StoreOnlineAddress,
    ChangeDefaultAddress,
    GetBasket,
    AddBasket,
    RemoveBasket,
    DeleteOnlineAddress,
    getCatsTreeApi,
    getCatsTreeApi_v2
}
